import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import UserList from "../../components/admin-component/user/UserList";
import UserStats from "../../components/admin-component/user/UserStats";
import HeadingOne from "../../components/baseui/HeadingOne";
import { pageSizeSelector } from "../../redux/surveySlice";
import {
  getSurveyors,
  getUsers,
  surveyorSelector,
  userSelector,
  usersSelector,
} from "../../redux/userSlice";

const User = () => {
  const dispatch = useDispatch();
  const users = useSelector(usersSelector);
  const pageSize = useSelector(pageSizeSelector);
  const surveyors = useSelector(surveyorSelector);
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState({ users: 0, surveyors: 0, admins: 0 });

  useEffect(() => {
    getAllUsers(pageSize, 1);
  }, []);

  useEffect(() => {
    if (!searchText) {
      setCount({
        users: users.count,
        surveyors: surveyors?.count,
        admins: users.count > 0 ? users.count - surveyors.count : 0,
      });
    }
  }, [users, surveyors]);

  const getAllUsers = (pageSize, pageNum) => {
    dispatch(getUsers({ pageNum, pageSize, searchText: searchText }));
    dispatch(getSurveyors({ pageNum: 1, searchText: "" }));
  };
  return (
    <>
      <div className="main-dashboard">
        <div className="mainWrapper">
          <div className="contentMain">
            <div className="topbar">
              <Row className="align-items-center">
                <Col lg="6">
                  <HeadingOne heading1="Users" />
                </Col>
              </Row>
            </div>
            <UserStats
              users={count.users}
              surveyors={count.surveyors}
              admins={count.admins}
            />
            <UserList
              text={searchText}
              setText={(e) => setSearchText(e)}
              users={users}
              getUsers={getAllUsers}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default User;
